// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import hrRequestDocumentEntity from './entities/hr-request-document.json';
import hrRequestDocumentMenu from '../pages/hr-request-document/menu.json';
import hrRequestDocumentFullForm from '../pages/hr-request-document/forms/full.json';
import hrRequestDocumentContextForm from '../pages/hr-request-document/forms/context.json';
import hrRequestDocumentMiniForm from '../pages/hr-request-document/forms/mini.json';
import hrRequestDocumentLookupForm from '../pages/hr-request-document/forms/lookup.json';
import hrRequestDocumentTableView from '../pages/hr-request-document/views/table.json';
import hrRequestDocumentCardsView from '../pages/hr-request-document/views/cards.json';
import hrRequestDocumentCalendarView from '../pages/hr-request-document/views/calendar.json';
import hrRequestDocumentDashboardView from '../pages/hr-request-document/views/dashboard.json';

/** Тип запису «Документ заявки» зі сторінками пакета: меню, форми та подання з pages/hr-request-document/. */
export const hrRequestDocumentDefinition: IRecordTypeDefinition = {
  ...hrRequestDocumentEntity,
  views: assembleViewSet({
      table: hrRequestDocumentTableView,
      cards: hrRequestDocumentCardsView,
      calendar: hrRequestDocumentCalendarView,
      dashboard: hrRequestDocumentDashboardView,
  }),
  form: hrRequestDocumentFullForm,
  forms: { full: hrRequestDocumentFullForm, context: hrRequestDocumentContextForm, mini: hrRequestDocumentMiniForm, lookup: hrRequestDocumentLookupForm },
  menu: hrRequestDocumentMenu,
} as IRecordTypeDefinition;
